// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
require('./_set-collection-of')('Map');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/modules/es7.map.of.js
// module id = 341
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11